import { unzip } from 'lodash';
import { useMemo } from 'react';

import type { Score } from '../types/correctScore';

export const useScoreInputRanges = (
  scores: Score[],
  [selectedHomeScore, selectedAwayScore]: Score
) => {
  const {
    scoresGroupedByTeam: [homeScores, awayScores],
    maxGoals
  } = useMemo(
    () => ({
      scoresGroupedByTeam: unzip(scores),
      maxGoals: Math.max(...scores.map(([homeScore, awayScore]) => homeScore + awayScore))
    }),
    [scores]
  );

  const homeRange = [
    Math.min(...homeScores),
    Math.min(maxGoals - selectedAwayScore, Math.max(...homeScores))
  ];

  const awayRange = [
    Math.min(...awayScores),
    Math.min(maxGoals - selectedHomeScore, Math.max(...awayScores))
  ];

  return { homeRange, awayRange };
};
